import { useParams, useNavigate } from 'react-router-dom';

import ProfileCard from './ContactSection/ProfileCard';
import InvoiceDuration from './InvoiceDuration';
import OrdersList from './OrdersList';
import PageSkeleton from './PageSkeleton';
import PaymentSection from './PaymentSection';

import Button from '@/components/Button';
import Page from '@/components/Page';
import PrimarySecondaryLayout from '@/components/PrimarySecondaryLayout';
import Stack from '@/components/Stack';
import { TIME_TO_REFRESH } from '@/constants/general';
import { useGetAccountQuery } from '@/graphql';
import useMediaQuery from '@/hooks/useMediaQuery';

const Account = () => {
  const phoneOnly = useMediaQuery('(max-width: 559px)');
  const navigate = useNavigate();
  const { accountId } = useParams();

  const query = useGetAccountQuery({
    variables: { accountId },
    pollInterval: TIME_TO_REFRESH,
  });

  if (!query.data) {
    return <PageSkeleton />;
  }

  const { account } = query.data;

  return (
    <Page
      headerPadding={phoneOnly}
      noPadding={phoneOnly}
      size={phoneOnly ? 'full' : 'lg'}
      subtitle={account.customer.name}
      title={account.name}
    >
      <Stack vertical gap={30}>
        <PrimarySecondaryLayout css={{ gap: phoneOnly ? 0 : 24 }}>
          <PrimarySecondaryLayout.Primary>
            <Stack vertical>
              <OrdersList account={account} />
            </Stack>
          </PrimarySecondaryLayout.Primary>
          <PrimarySecondaryLayout.Secondary>
            <Stack vertical verticalGap={phoneOnly ? 0 : 24}>
              <ProfileCard account={account} phoneOnly={phoneOnly} />
              <InvoiceDuration account={account} phoneOnly={phoneOnly} />
              <PaymentSection account={account} />
            </Stack>
          </PrimarySecondaryLayout.Secondary>
        </PrimarySecondaryLayout>
        <Stack justify="end">
          <Button
            a11yLabel="Go back"
            appearance="primary"
            id="btn-go-back"
            label="Go Back"
            type="button"
            onClick={() => navigate(-1)}
          />
        </Stack>
      </Stack>
    </Page>
  );
};

export default Account;
